import React from "react";
import { Card, CardContent, Box, Typography } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";

export default function StatsCard({
  title,
  value,
  icon: Icon,
  trend,
  trendValue,
  color = "primary",
}) {
  const isPositive = trend === "up";

  return (
    <Card
      sx={{
        height: "100%",
        transition: "all 0.3s ease",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: 4,
        },
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              fontWeight: 600,
              textTransform: "uppercase",
              fontSize: "0.75rem",
              letterSpacing: "0.05em",
            }}
          >
            {title}
          </Typography>
          {Icon && (
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: `${color}.lighter`,
                color: `${color}.main`,
              }}
            >
              <Icon sx={{ fontSize: 24 }} />
            </Box>
          )}
        </Box>

        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            color: "text.primary",
            mb: 1,
            letterSpacing: "-0.02em",
          }}
        >
          {value}
        </Typography>

        {trendValue && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            {isPositive ? (
              <TrendingUpIcon sx={{ fontSize: 18, color: "success.main" }} />
            ) : (
              <TrendingDownIcon sx={{ fontSize: 18, color: "error.main" }} />
            )}
            <Typography
              variant="body2"
              sx={{
                color: isPositive ? "success.main" : "error.main",
                fontWeight: 600,
              }}
            >
              {trendValue}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              vs mois dernier
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
